// extracted by mini-css-extract-plugin
module.exports = {"inputList":"StatusWidgetContainer_inputList__pZrhJ"};